import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const instutionalFuctionFields = `
id
functionUniqueId
functionDutyName
functionCreateddate
`


export const GET_ALL_INSTUTIONAL_FUNCTION = gql`
  query GetAllFunctions($instituteUniqueId: String) {
    getAllFunctions(instituteUniqueId: $instituteUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${instutionalFuctionFields}
    }
  }
}
`

export const CREATE_INSTUTION_FUNCTION = gql`
mutation createInstitutionFunctionMutation($input: InstitutionFunctionInputObjects!) {
    createInstitutionFunctionMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${instutionalFuctionFields}
    }
  }
}
`
export const UPDATE_INSTUTION_FUNCTION = gql`
mutation updateInstitutionFunctionMutation($input: InstitutionFunctionInputObjects!) {
    updateInstitutionFunctionMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${instutionalFuctionFields}
    }
  }
}
`


export const DELETE_INSTUTION_FUNCTION = gql`
mutation deleteInstitutionFunctionMutation($functionUniqueId: String!) {
  deleteInstitutionFunctionMutation(functionUniqueId: $functionUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`

export const deleteInstitutionServiceFunctionMutation = gql`
  mutation DeleteInstitutionServiceFunctionMutation($uniqueId: String!) {
    deleteInstitutionServiceFunctionMutation(uniqueId: $uniqueId) {
      response {
        id
        status
        code
        message
      }
    }
  }`
